import React, { useState, useEffect, useCallback } from 'react'
import styles from './Wazzup.module.scss'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import { superAxiosRequest } from 'axiosApi'

const WazzupChat = () => {
  const [iframeUrl, setIframeUrl] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchWazzupUrl = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    setIframeUrl(null)

    try {
      const res = await superAxiosRequest({
        method: 'get',
        link: 'integration/wazzup_iframe_employee_chats',
        crm: true,
      })

      const url = res.data?.url || res.data?.iframe_url

      if (!url || typeof url !== 'string') {
        throw new Error('Бэкенд вернул некорректную ссылку на чат')
      }

      setIframeUrl(url)
    } catch (err) {
      console.error('[WazzupChat] Ошибка загрузки:', err)
      setError(
        err.response?.data?.message ||
          err.message ||
          'Не удалось загрузить чаты Wazzup',
      )
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchWazzupUrl()
  }, [fetchWazzupUrl])

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {isLoading && (
          <div className={styles.loaderWrapper}>
            <Loader />
          </div>
        )}

        {!isLoading && error && (
          <div className={styles.errorContainer}>
            <p>{error}</p>
            <button
              type='button'
              className={styles.retryBtn}
              onClick={fetchWazzupUrl}
            >
              Повторить попытку
            </button>
          </div>
        )}

        {!isLoading && !error && !iframeUrl && (
          <div className={styles.emptyState}>
            <p>
              Ссылка на чаты отсутствует. Возможно, вы не назначены
              ответственным ни в одной сделке.
            </p>
          </div>
        )}

        {!isLoading && !error && iframeUrl && (
          <div className={styles.iframeWrapper}>
            <iframe
              src={iframeUrl}
              title='Wazzup Chats'
              className={styles.iframe}
              allow='microphone *; clipboard-write *'
              sandbox='allow-scripts allow-same-origin allow-forms allow-popups allow-presentation'
              referrerPolicy='no-referrer'
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default WazzupChat
